export default {
  "userRisk.title": "User Risk Management",
  "userRisk.thead.riskId": "Risk ID",
  "userRisk.thead.userId": "User ID",
  "userRisk.thead.email": "Email",
  "userRisk.thead.userName": "User Name",
  "userRisk.thead.firstName": "Firs tName",
  "userRisk.thead.lastName": "Last Name",
  "userRisk.thead.inviterUserno": "Inviter User No",
  "userRisk.thead.inviterEmail": "Inviter Email",
  "userRisk.thead.inviterName": "Inviter Name",
  "userRisk.thead.inviterFirstName": "InviterFirstName",
  "userRisk.thead.inviterLastName": "InviterLastName",
  "userRisk.thead.riskTypes": "Risk Types",
  "userRisk.thead.riskContent": "Risk Content",
  "userRisk.thead.riskTime": "Risk Time",
  "userRisk.thead.userStatus": "User Status",
  "userRisk.thead.inviterStatusDesc": "Inviter Status",
  "userRisk.thead.action": "Action",
  "userRisk.disableUser": "Disable User",
  "userRisk.enableUser": "Enable User",
  "userRisk.disableInviter": "Disable Inviter",
  "userRisk.enableInviter": "Enable Inviter",
  "userRisk.confirm": "Confirm",
  "userRisk.cancel": "Cancel",
  "userRisk.confirmDisableUser": "Are you sure you want to disable this user?",
  "userRisk.confirmDisableInviter":
    "Are you sure you want to disable this inviter?",
  "userRisk.copySuccess": "Copy Success",
};
